import 'bootstrap';

import './assets/js/global.js';
import './assets/js/skip-link-focus-fix.js';
import './assets/js/main.js';
import './assets/js/navigation.js';

import './assets/sass/main.scss';

